import { FaCheck } from 'react-icons/fa';
import { cn } from '../../lib/helpers.ts';

interface DayProgressIndicatorProps {
    day: number;
    status: 'completed' | 'missed' | 'empty';
    isToday: boolean;
}

export default function DayProgressIndicator({
    day,
    status,
    isToday,
}: DayProgressIndicatorProps) {
    const days = ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'];

    return (
        <div className="inline-flex flex-col items-center">
            <span
                className={cn(
                    'mb-1 text-sm font-bold text-ink-700',
                    isToday && 'text-green-500'
                )}
            >
                {days[day]}
            </span>
            <div
                className={cn(
                    'flex h-6 w-6 items-center justify-center rounded-full',
                    status === 'completed' && 'bg-green-500',
                    status === 'empty' &&
                        'border-2 border-green-500 bg-green-100'
                )}
            >
                {status === 'completed' && (
                    <FaCheck size={11} className="fill-white" />
                )}
            </div>
        </div>
    );
}
